// extracted by mini-css-extract-plugin
module.exports = {"uiError":"var(--uiError)","downloadAlertMessage":"DownloadAlert_downloadAlertMessage__I7_fX"};